import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import MenuPreferencesFields from './MenuPreferencesFields';
import { DEFAULT_MENU_PREFERENCES } from './menuPreferencesConstants';
import './MenuPreferencesOnboarding.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const MenuPreferencesOnboarding = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [preferences, setPreferences] = useState(DEFAULT_MENU_PREFERENCES);
  const [saving, setSaving] = useState(false);

  const nextPath = searchParams.get('next') || '/meal-plan';

  const finish = (path = nextPath) => {
    navigate(path, { replace: true });
  };

  const savePreferences = async (payload) => {
    const token = localStorage.getItem('token');
    if (!token) {
      finish('/');
      return;
    }
    const res = await fetch(`${API_URL}/mealplan/preferences`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ preferences: payload })
    });
    if (!res.ok) {
      throw new Error('Failed to save preferences');
    }
  };

  const handleSkip = async () => {
    setSaving(true);
    try {
      await savePreferences({
        ...DEFAULT_MENU_PREFERENCES,
        weeklyEmailEnabled: preferences.weeklyEmailEnabled !== false,
        onboardingCompleted: true
      });
      toast.success('You can add menu preferences later in your profile.');
      finish();
    } catch (error) {
      console.error(error);
      toast.error('Could not save. You can try again from your profile.');
      finish();
    } finally {
      setSaving(false);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await savePreferences({
        ...preferences,
        onboardingCompleted: true
      });
      toast.success(preferences.weeklyEmailEnabled !== false
        ? 'Preferences saved. We’ll send weekly meal ideas to your inbox.'
        : 'Preferences saved.');
      finish();
    } catch (error) {
      console.error(error);
      toast.error('Failed to save preferences');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="menu-onboarding">
      <div className="menu-onboarding-card">
        <p className="menu-onboarding-kicker">Welcome to FreshFitLab</p>
        <h1>Tell us how you like to eat</h1>
        <p className="menu-onboarding-lead">
          Optional — skip this if you want. We’ll still send weekly meal ideas, and you can personalize them later in your profile.
        </p>
        <form onSubmit={handleSave}>
          <MenuPreferencesFields
            preferences={preferences}
            onChange={(field, value) => setPreferences((prev) => ({ ...prev, [field]: value }))}
          />
          <div className="menu-onboarding-actions">
            <button type="button" className="menu-onboarding-skip" onClick={handleSkip} disabled={saving}>
              Skip for now
            </button>
            <button type="submit" className="menu-onboarding-save" disabled={saving}>
              {saving ? 'Saving…' : 'Save preferences'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MenuPreferencesOnboarding;
